module.exports = __webpack_public_path__ + "media/images/flags/4x3/blm-da571027c3e54debf2fefcc68b2dcc3a.svg";